import React from 'react';

const CloseIcon = ({}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M14.9497 16.364C15.1447 16.559 15.4007 16.657 15.6567 16.657C15.9127 16.657 16.1687 16.559 16.3637 16.364C16.7547 15.973 16.7547 15.341 16.3637 14.95L13.2429 11.8288L16.365 8.70798C16.755 8.31698 16.755 7.68398 16.365 7.29398C15.974 6.90298 15.341 6.90298 14.951 7.29398L11.829 10.4147L8.70772 7.29301C8.31772 6.90201 7.68472 6.90201 7.29372 7.29301C6.90372 7.68301 6.90372 8.31601 7.29372 8.70701L10.4148 11.8285L7.29301 14.949C6.90201 15.34 6.90201 15.972 7.29301 16.363C7.48801 16.558 7.74401 16.656 8.00001 16.656C8.25601 16.656 8.51201 16.558 8.70701 16.363L11.8287 13.2425L14.9497 16.364Z"
          fill="#0033A0"/>
  </svg>
);

export default CloseIcon;